import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('layout.app');
import { OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

type QuickToolPosition = { left: number; top: number };
type QuickToolDragState = {
    pointerId: number;
    startX: number;
    startY: number;
    originLeft: number;
    originTop: number;
    moved: boolean;
};
type QuickToolPanelPlacement = {
    vertical: 'above' | 'below';
    align: 'left' | 'right';
};

@Component({
    selector: 'wiz-layout-app',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/layout.app/view.scss */
:host {
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
}

.app-container {
  --app-shell-width: 480px;
  max-width: var(--app-shell-width);
  margin: 0 auto;
  min-height: 100%;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.05);
  width: 100%;
}

.app-layout-scroll {
  padding-bottom: calc(var(--th-nav-height) + env(safe-area-inset-bottom, 0px) + 12px);
  min-width: 0;
}

.quick-tool {
  position: absolute;
  left: 0;
  top: 0;
  width: 54px;
  height: 54px;
  z-index: 45;
  pointer-events: none;
  transition: transform 0.18s cubic-bezier(0.2, 0.8, 0.2, 1);
  will-change: transform;
}

.quick-tool-dragging {
  transition: none;
}

.quick-tool-panel, .quick-tool-trigger {
  pointer-events: auto;
}

.quick-tool-trigger {
  width: 54px;
  height: 54px;
  min-height: 54px;
  border: 1px solid var(--th-line);
  border-radius: 9999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background-color: var(--th-primary);
  box-shadow: 0 12px 28px rgba(17, 24, 39, 0.18);
  touch-action: none;
  transition: transform 0.15s ease, box-shadow 0.15s ease;
}

.quick-tool-trigger:active, .quick-tool-dragging .quick-tool-trigger {
  transform: scale(0.96);
  box-shadow: 0 8px 20px rgba(17, 24, 39, 0.22);
}

.quick-tool-icon {
  width: 28px;
  height: 28px;
}

.quick-tool-panel {
  position: absolute;
  width: min(288px, 100vw - 32px);
  max-height: calc(100vh - var(--th-nav-height) - 32px);
  overflow: auto;
  padding: 12px;
  border: 1px solid var(--th-line);
  border-radius: 16px;
  background-color: var(--th-card-bg);
  box-shadow: 0 18px 36px rgba(17, 24, 39, 0.18);
}

.quick-tool-panel-above {
  bottom: 64px;
}

.quick-tool-panel-below {
  top: 64px;
}

.quick-tool-panel-align-left {
  left: 0;
}

.quick-tool-panel-align-right {
  right: 0;
}

.quick-tool-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.quick-tool-title, .quick-tool-section-title {
  margin: 0;
  color: var(--th-text);
  font-size: var(--th-font-small);
  font-weight: 700;
  line-height: 1.35;
}

.quick-tool-hint {
  margin: 2px 0 0;
  color: var(--th-text-muted);
  font-size: var(--th-font-xs);
  line-height: 1.3;
}

.quick-tool-section {
  margin-top: 12px;
}

.quick-tool-font-actions, .quick-tool-mode-actions {
  display: grid;
  margin-top: 8px;
  gap: 8px;
}

.quick-tool-font-actions {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.quick-tool-mode-actions {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.quick-tool-option, .quick-tool-mode-option {
  min-width: 0;
  min-height: 58px;
  padding: 8px 6px;
  border: 1px solid var(--th-line);
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  color: var(--th-text);
  background-color: var(--th-card-bg);
}

.quick-tool-option-active {
  border-width: 2px;
  border-color: var(--th-primary);
  background-color: var(--th-primary-light);
  color: var(--th-primary-dark);
}

.quick-tool-option-marker {
  font-size: 18px;
  font-weight: 800;
  line-height: 1;
}

.quick-tool-option-label {
  font-size: 13px;
  font-weight: 700;
  line-height: 1.25;
}

.quick-tool-mode-icon {
  width: 20px;
  height: 20px;
}

.quick-tool-theme-actions {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.quick-tool-theme-option {
  width: 42px;
  height: 42px;
  border: 2px solid transparent;
  border-radius: 9999px;
  color: #fff;
  font-size: 13px;
  font-weight: 800;
}

.quick-tool-theme-option-active {
  border-color: var(--th-text);
  box-shadow: 0 0 0 3px var(--th-primary-light);
}

.quick-tool-footer {
  display: flex;
  gap: 8px;
  margin-top: 12px;
}

.quick-tool-text-button {
  flex: 1;
  min-height: 40px;
  border: 1px solid var(--th-line);
  border-radius: 12px;
  color: var(--th-text);
  background-color: var(--th-surface-soft);
  font-size: var(--th-font-small);
  font-weight: 700;
}

.quick-tool-primary-button {
  border-color: var(--th-primary);
  color: #fff;
  background-color: var(--th-primary);
}

@media (min-width: 481px) {
  :host {
    background-color: #f5f5f5;
  }
}`],
})
export class LayoutAppComponent implements OnInit, OnDestroy {
    public theme: string = 'b';
    public mode: string = 'light';
    public fontSize: string = 'medium';
    public quickToolOpen: boolean = false;
    public quickToolEnabled: boolean = true;
    public quickToolDragging: boolean = false;
    public quickToolPosition: QuickToolPosition = { left: 410, top: 620 };
    public quickToolPanelVertical: 'above' | 'below' = 'above';
    public quickToolPanelAlign: 'left' | 'right' = 'right';
    public isAuthed: boolean = false;
    public readonly fontSizeOptions: any[] = [
        { id: 'small', label: '작게', marker: 'A-' },
        { id: 'medium', label: '보통', marker: 'A' },
        { id: 'large', label: '크게', marker: 'A+' }
    ];
    public readonly quickModeOptions: any[] = [
        { id: 'light', label: '라이트', icon: 'sun' },
        { id: 'dark', label: '다크', icon: 'moon' }
    ];
    public readonly quickThemeOptions: any[] = [
        { id: 'a', label: 'A', color: '#c27a1a' },
        { id: 'b', label: 'B', color: '#10b981' },
        { id: 'c', label: 'C', color: '#8b5cf6' }
    ];
    private quickToolDragState: QuickToolDragState | null = null;
    private ignoreNextQuickToolClick: boolean = false;
    private quickToolMoveFrame: number | null = null;
    private queuedQuickToolPosition: QuickToolPosition | null = null;
    private readonly quickToolSize: number = 54;
    private readonly quickToolMargin: number = 12;
    private readonly quickToolNavOffset: number = 92;
    private readonly quickToolPanelGap: number = 10;
    private readonly quickToolPanelMaxWidth: number = 288;
    private readonly quickToolPanelFallbackHeight: number = 360;
    private readonly themeChangeHandler: EventListener = (event) => {
        const customEvent = event as CustomEvent<string>;
        this.theme = customEvent.detail || this.getStorageValue('app-theme', 'b');
        void this.renderSafely();
    };
    private readonly modeChangeHandler: EventListener = (event) => {
        const customEvent = event as CustomEvent<string>;
        this.mode = customEvent.detail || this.getStorageValue('app-mode', 'light');
        void this.renderSafely();
    };
    private readonly fontSizeChangeHandler: EventListener = (event) => {
        const customEvent = event as CustomEvent<string>;
        this.fontSize = customEvent.detail || this.getStorageValue('app-font-size', 'medium');
        void this.renderSafely();
    };
    private readonly quickToolEnabledChangeHandler: EventListener = (event) => {
        const customEvent = event as CustomEvent<boolean>;
        this.quickToolEnabled = typeof customEvent.detail === 'boolean'
            ? customEvent.detail
            : this.getStorageValue('app-quick-tool-enabled', 'on') !== 'off';
        if (!this.quickToolEnabled) {
            this.quickToolOpen = false;
        }
        void this.renderSafely();
    };
    private readonly resizeHandler: EventListener = () => {
        this.constrainQuickToolPosition(true, this.quickToolOpen);
        void this.renderSafely();
    };

    constructor(@Inject( Service) public service: Service) { }

    private getStorageValue(key: string, fallback: string): string {
        try {
            return localStorage.getItem(key) || fallback;
        } catch {
            return fallback;
        }
    }

    private getAppMetrics() {
        const container = document.querySelector('.app-container') as HTMLElement | null;
        const rect = container?.getBoundingClientRect();
        const visualViewport = window.visualViewport;
        const viewportWidth = visualViewport?.width || window.innerWidth || 480;
        const viewportHeight = visualViewport?.height || window.innerHeight || 720;
        const width = Math.min(rect?.width || Math.min(viewportWidth, 480), viewportWidth);
        const height = Math.min(rect?.height || viewportHeight, viewportHeight);
        return { width, height };
    }

    private getQuickToolAvailableBottom(metrics = this.getAppMetrics()): number {
        return Math.max(this.quickToolMargin + this.quickToolSize, metrics.height - this.quickToolNavOffset);
    }

    private getQuickToolPanelSize(metrics = this.getAppMetrics()) {
        const panel = document.querySelector('.quick-tool-panel') as HTMLElement | null;
        const rect = panel?.getBoundingClientRect();
        const maxWidth = Math.max(this.quickToolSize, metrics.width - this.quickToolMargin * 2);
        const maxHeight = Math.max(140, this.getQuickToolAvailableBottom(metrics) - this.quickToolMargin * 2);
        return {
            width: Math.min(rect?.width || this.quickToolPanelMaxWidth, maxWidth),
            height: Math.min(rect?.height || this.quickToolPanelFallbackHeight, maxHeight)
        };
    }

    private clampValue(value: number, min: number, max: number): number {
        if (max < min) return min;
        return Math.min(Math.max(value, min), max);
    }

    private clampWithFallback(value: number, min: number, max: number, fallbackMin: number, fallbackMax: number): number {
        if (max < min) {
            return this.clampValue(value, fallbackMin, fallbackMax);
        }
        return this.clampValue(value, min, max);
    }

    private getDefaultQuickToolPosition(): QuickToolPosition {
        const metrics = this.getAppMetrics();
        return this.clampQuickToolPosition({
            left: metrics.width - this.quickToolSize - 16,
            top: metrics.height - this.quickToolSize - this.quickToolNavOffset - 16
        });
    }

    private resolveQuickToolPanelPlacement(
        position: QuickToolPosition,
        metrics = this.getAppMetrics(),
        panel = this.getQuickToolPanelSize(metrics)
    ): QuickToolPanelPlacement {
        const belowSpace = this.getQuickToolAvailableBottom(metrics) - (position.top + this.quickToolSize + this.quickToolPanelGap);
        const aboveSpace = position.top - this.quickToolPanelGap;
        const rightSpace = metrics.width - position.left;
        const leftSpace = position.left + this.quickToolSize;

        return {
            vertical: belowSpace >= panel.height || belowSpace >= aboveSpace ? 'below' : 'above',
            align: rightSpace >= panel.width || rightSpace >= leftSpace ? 'left' : 'right'
        };
    }

    private clampQuickToolPositionForPanel(
        position: QuickToolPosition,
        placement: QuickToolPanelPlacement,
        metrics = this.getAppMetrics(),
        panel = this.getQuickToolPanelSize(metrics)
    ): QuickToolPosition {
        const minLeft = this.quickToolMargin;
        const minTop = this.quickToolMargin;
        const maxLeft = Math.max(minLeft, metrics.width - this.quickToolSize - this.quickToolMargin);
        const maxTop = Math.max(minTop, this.getQuickToolAvailableBottom(metrics) - this.quickToolSize);
        let panelMinLeft = minLeft;
        let panelMaxLeft = maxLeft;
        let panelMinTop = minTop;
        let panelMaxTop = maxTop;

        if (placement.align === 'left') {
            panelMaxLeft = Math.min(panelMaxLeft, metrics.width - this.quickToolMargin - panel.width);
        } else {
            panelMinLeft = Math.max(panelMinLeft, this.quickToolMargin + panel.width - this.quickToolSize);
        }

        if (placement.vertical === 'below') {
            panelMaxTop = Math.min(panelMaxTop, this.getQuickToolAvailableBottom(metrics) - this.quickToolSize - this.quickToolPanelGap - panel.height);
        } else {
            panelMinTop = Math.max(panelMinTop, this.quickToolMargin + panel.height + this.quickToolPanelGap);
        }

        return {
            left: this.clampWithFallback(position.left, panelMinLeft, panelMaxLeft, minLeft, maxLeft),
            top: this.clampWithFallback(position.top, panelMinTop, panelMaxTop, minTop, maxTop)
        };
    }

    private clampQuickToolPosition(position: QuickToolPosition, keepPanelVisible: boolean = false): QuickToolPosition {
        const metrics = this.getAppMetrics();
        const minLeft = this.quickToolMargin;
        const minTop = this.quickToolMargin;
        const maxLeft = Math.max(minLeft, metrics.width - this.quickToolSize - this.quickToolMargin);
        const maxTop = Math.max(minTop, this.getQuickToolAvailableBottom(metrics) - this.quickToolSize);
        let next = {
            left: this.clampValue(position.left, minLeft, maxLeft),
            top: this.clampValue(position.top, minTop, maxTop)
        };

        if (!keepPanelVisible) {
            return next;
        }

        const panel = this.getQuickToolPanelSize(metrics);
        for (let i = 0; i < 2; i++) {
            const placement = this.resolveQuickToolPanelPlacement(next, metrics, panel);
            next = this.clampQuickToolPositionForPanel(next, placement, metrics, panel);
        }

        return next;
    }

    private loadQuickToolPosition() {
        let position = this.getDefaultQuickToolPosition();
        try {
            const saved = localStorage.getItem('app-quick-tool-position');
            if (saved) {
                const parsed = JSON.parse(saved);
                if (Number.isFinite(parsed?.left) && Number.isFinite(parsed?.top)) {
                    position = { left: parsed.left, top: parsed.top };
                }
            }
        } catch {
        }

        this.quickToolPosition = this.clampQuickToolPosition(position);
        this.updateQuickToolPanelPlacement();
    }

    private persistQuickToolPosition() {
        try {
            localStorage.setItem('app-quick-tool-position', JSON.stringify(this.quickToolPosition));
        } catch {
        }
    }

    private flushQueuedQuickToolPosition() {
        if (this.quickToolMoveFrame !== null) {
            cancelAnimationFrame(this.quickToolMoveFrame);
            this.quickToolMoveFrame = null;
        }

        if (this.queuedQuickToolPosition) {
            this.quickToolPosition = this.queuedQuickToolPosition;
            this.queuedQuickToolPosition = null;
        }
    }

    private scheduleQuickToolPosition(position: QuickToolPosition) {
        this.queuedQuickToolPosition = position;
        if (this.quickToolMoveFrame !== null) return;

        this.quickToolMoveFrame = requestAnimationFrame(() => {
            if (this.queuedQuickToolPosition) {
                this.quickToolPosition = this.queuedQuickToolPosition;
                this.queuedQuickToolPosition = null;
                this.updateQuickToolPanelPlacement();
            }
            this.quickToolMoveFrame = null;
        });
    }

    private constrainQuickToolPosition(persist: boolean = false, keepPanelVisible: boolean = false) {
        this.flushQueuedQuickToolPosition();
        this.quickToolPosition = this.clampQuickToolPosition(this.quickToolPosition, keepPanelVisible);
        this.updateQuickToolPanelPlacement();
        if (persist) {
            this.persistQuickToolPosition();
        }
    }

    private updateQuickToolPanelPlacement(position = this.quickToolPosition) {
        const placement = this.resolveQuickToolPanelPlacement(position);
        this.quickToolPanelVertical = placement.vertical;
        this.quickToolPanelAlign = placement.align;
    }

    private async renderSafely() {
        try {
            await this.service.render();
        } catch {
        }
    }

    private isKnownFontSize(fontSizeId: string): boolean {
        return this.fontSizeOptions.some((option) => option.id === fontSizeId);
    }

    private isKnownMode(modeId: string): boolean {
        return this.quickModeOptions.some((option) => option.id === modeId);
    }

    private isKnownTheme(themeId: string): boolean {
        return this.quickThemeOptions.some((option) => option.id === themeId);
    }

    private setFontSize(fontSizeId: string) {
        if (!this.isKnownFontSize(fontSizeId)) return;

        this.fontSize = fontSizeId;
        try {
            localStorage.setItem('app-font-size', fontSizeId);
        } catch {
        }

        const containers = document.querySelectorAll('.app-container, .auth-container');
        containers.forEach((container) => {
            (container as HTMLElement).setAttribute('data-font-size', fontSizeId);
        });
    }

    private setMode(modeId: string) {
        if (!this.isKnownMode(modeId)) return;

        this.mode = modeId;
        try {
            localStorage.setItem('app-mode', modeId);
        } catch {
        }

        const container = document.querySelector('.app-container');
        if (container) {
            container.setAttribute('data-mode', modeId);
        }
    }

    private setTheme(themeId: string) {
        if (!this.isKnownTheme(themeId)) return;

        this.theme = themeId;
        try {
            localStorage.setItem('app-theme', themeId);
        } catch {
        }

        const container = document.querySelector('.app-container');
        if (container) {
            container.setAttribute('data-theme', themeId);
        }
    }

    public get quickToolTransform(): string {
        return `translate3d(${this.quickToolPosition.left}px, ${this.quickToolPosition.top}px, 0)`;
    }

    public async toggleQuickTool(event?: MouseEvent) {
        if (event) {
            event.stopPropagation();
        }

        if (this.ignoreNextQuickToolClick || this.quickToolDragging || !this.quickToolEnabled) {
            this.ignoreNextQuickToolClick = false;
            return;
        }

        this.quickToolOpen = !this.quickToolOpen;
        if (this.quickToolOpen) {
            this.constrainQuickToolPosition(true, true);
        } else {
            this.updateQuickToolPanelPlacement();
        }
        await this.renderSafely();

        if (this.quickToolOpen) {
            setTimeout(() => {
                this.constrainQuickToolPosition(true, true);
                void this.renderSafely();
            }, 0);
        }
    }

    public startQuickToolDrag(event: PointerEvent) {
        if (!this.quickToolEnabled) return;

        this.quickToolDragState = {
            pointerId: event.pointerId,
            startX: event.clientX,
            startY: event.clientY,
            originLeft: this.quickToolPosition.left,
            originTop: this.quickToolPosition.top,
            moved: false
        };
        this.quickToolDragging = true;

        try {
            (event.currentTarget as HTMLElement).setPointerCapture(event.pointerId);
        } catch {
        }
    }

    public moveQuickTool(event: PointerEvent) {
        if (!this.quickToolDragState || this.quickToolDragState.pointerId !== event.pointerId) return;

        const dx = event.clientX - this.quickToolDragState.startX;
        const dy = event.clientY - this.quickToolDragState.startY;
        if ((Math.abs(dx) > 3 || Math.abs(dy) > 3) && !this.quickToolDragState.moved) {
            this.quickToolDragState.moved = true;
            if (this.quickToolOpen) {
                this.quickToolOpen = false;
                void this.renderSafely();
            }
        }

        if (!this.quickToolDragState.moved) return;

        event.preventDefault();
        this.scheduleQuickToolPosition(this.clampQuickToolPosition({
            left: this.quickToolDragState.originLeft + dx,
            top: this.quickToolDragState.originTop + dy
        }));
    }

    public async endQuickToolDrag(event: PointerEvent) {
        if (!this.quickToolDragState || this.quickToolDragState.pointerId !== event.pointerId) return;

        const moved = this.quickToolDragState.moved;
        this.flushQueuedQuickToolPosition();
        this.quickToolDragState = null;
        this.quickToolDragging = false;

        try {
            (event.currentTarget as HTMLElement).releasePointerCapture(event.pointerId);
        } catch {
        }

        if (moved) {
            event.preventDefault();
            event.stopPropagation();
            this.ignoreNextQuickToolClick = true;
            this.constrainQuickToolPosition(true);
            setTimeout(() => {
                this.ignoreNextQuickToolClick = false;
            }, 0);
        }

        await this.renderSafely();
    }

    public async cancelQuickToolDrag(event: PointerEvent) {
        if (!this.quickToolDragState || this.quickToolDragState.pointerId !== event.pointerId) return;

        this.flushQueuedQuickToolPosition();
        this.quickToolDragState = null;
        this.quickToolDragging = false;
        this.constrainQuickToolPosition(true);
        await this.renderSafely();
    }

    public async changeFontSize(fontSizeId: string) {
        if (!this.isKnownFontSize(fontSizeId)) return;

        this.setFontSize(fontSizeId);
        window.dispatchEvent(new CustomEvent('app-font-size-change', { detail: fontSizeId }));
        await this.renderSafely();
    }

    public async changeMode(modeId: string) {
        if (!this.isKnownMode(modeId)) return;

        this.setMode(modeId);
        window.dispatchEvent(new CustomEvent('app-mode-change', { detail: modeId }));
        await this.renderSafely();
    }

    public async changeTheme(themeId: string) {
        if (!this.isKnownTheme(themeId)) return;

        this.setTheme(themeId);
        window.dispatchEvent(new CustomEvent('app-theme-change', { detail: themeId }));
        await this.renderSafely();
    }

    public async resetQuickToolPosition() {
        this.quickToolPosition = this.clampQuickToolPosition(this.getDefaultQuickToolPosition(), this.quickToolOpen);
        this.persistQuickToolPosition();
        this.updateQuickToolPanelPlacement();
        await this.renderSafely();
    }

    public goSettings() {
        this.quickToolOpen = false;
        this.service.href('/settings');
    }

    public isFontSizeSelected(fontSizeId: string): boolean {
        return this.fontSize === fontSizeId;
    }

    public isModeSelected(modeId: string): boolean {
        return this.mode === modeId;
    }

    public isThemeSelected(themeId: string): boolean {
        return this.theme === themeId;
    }

    public async ngOnInit() {
        try {
            await this.service.init();

            let res = await wiz.call("check_auth");
            if (!res.data?.authenticated) {
                this.service.href('/login');
                return;
            }

            this.isAuthed = true;
            this.theme = this.getStorageValue('app-theme', 'b');
            this.mode = this.getStorageValue('app-mode', 'light');
            this.fontSize = this.getStorageValue('app-font-size', 'medium');
            this.quickToolEnabled = this.getStorageValue('app-quick-tool-enabled', 'on') !== 'off';
            this.loadQuickToolPosition();
            window.addEventListener('app-theme-change', this.themeChangeHandler);
            window.addEventListener('app-mode-change', this.modeChangeHandler);
            window.addEventListener('app-font-size-change', this.fontSizeChangeHandler);
            window.addEventListener('app-quick-tool-enabled-change', this.quickToolEnabledChangeHandler);
            window.addEventListener('resize', this.resizeHandler);
            await this.renderSafely();
            setTimeout(() => {
                this.constrainQuickToolPosition(true, this.quickToolOpen);
                void this.renderSafely();
            }, 0);
        } catch {
            try {
                this.service.href('/login');
            } catch {
            }
        }
    }

    public ngOnDestroy() {
        window.removeEventListener('app-theme-change', this.themeChangeHandler);
        window.removeEventListener('app-mode-change', this.modeChangeHandler);
        window.removeEventListener('app-font-size-change', this.fontSizeChangeHandler);
        window.removeEventListener('app-quick-tool-enabled-change', this.quickToolEnabledChangeHandler);
        window.removeEventListener('resize', this.resizeHandler);
        this.flushQueuedQuickToolPosition();
    }
}

export default LayoutAppComponent;